import { $, html, View } from 'rune-ts';
import klass from './ExpandableText.module.scss';
import { debounce } from '../../../../shared/util';
import {
  ChevronDownIcon,
  ChevronUpIcon,
} from '@services/MarppleShop/shared/components/atoms/Icon/foundation_icons';

export interface ExpandableTextData {
  text: string; // 텍스트
  textKlass: string; //
  buttonKlass: string; //
  buttonLabelMore: string; // "더보기" 커스터마이징
  buttonLabelLess: string; // "접기" 커스터마이징
  lineClamp: number; //
}

export class ExpandableText extends View<ExpandableTextData> {
  private _is_expanded = false;
  private _is_show = false;
  constructor(data: ExpandableTextData) {
    super(data);
  }

  override template() {
    const style = this.data.lineClamp
      ? html` style="display: -webkit-box;overflow: hidden;text-overflow: ellipsis;-webkit-line-clamp:
        ${this._getIsExpanded() ? 'unset' : this.data.lineClamp};-webkit-box-orient: vertical;"`
      : ``;
    return html`<div class="${klass.expandable_text}">
      <div class="${klass.text} ${this.data.textKlass}" ${style}>${html.preventEscape(this.data.text)}</div>
      <button
        type="button"
        class="${klass.expandable_button} ${this.data.buttonKlass} ${this._getIsShow() ? klass.show : ''}"
      >
        ${this._getIsExpanded()
          ? html`${this.data.buttonLabelLess}${ChevronUpIcon()}`
          : html`${this.data.buttonLabelMore}${ChevronDownIcon()}`}
      </button>
    </div>`;
  }

  private _getIsExpanded() {
    return this._is_expanded;
  }

  private _setIsExpanded(bool: boolean) {
    this._is_expanded = bool;
    return this;
  }

  private _getIsShow() {
    return this._is_show;
  }

  private _setIsShow(is_show: boolean) {
    this._is_show = is_show;
    return this;
  }

  private _initializeButton() {
    const text_elem = $(this.element()).find(`.${klass.text}`)?.element();
    if (!text_elem) {
      return;
    }
    const text_computed_style = getComputedStyle(text_elem);
    const line_height = parseFloat(text_computed_style.lineHeight);
    if (isNaN(line_height)) {
      return console.error('text 에 lineHeight 가 있어야함 ');
    }

    const line_clamp = this.data.lineClamp;
    if (!line_clamp) {
      return console.error('text 에 -webkit-line-clamp 가 있어야함 ');
    }
    const now_height = line_height * line_clamp;
    const button$ = $(this.element()).find(`.${klass.expandable_button}`);
    if (button$) {
      if (text_elem.scrollHeight > now_height) {
        button$.addClass(klass.show);
        this._setIsShow(true);
      }
    }
  }

  protected override onRender() {
    this._initializeButton();
    /* 윈도우 리사이즈에 이벤트 */
    window.addEventListener(
      'resize',
      debounce(() => {
        this._setIsShow(false)._setIsExpanded(false).redraw()._initializeButton();
      }, 100),
    );

    this.delegate('click', `.${klass.expandable_button}`, () => {
      this._setIsExpanded(!this._getIsExpanded()).redraw();
    });
  }
}
